import {NgModule} from '@angular/core';
import {AuthenticationModule} from '@ngx-ivengi/authentication';
import {ValidatorModule} from '@ngx-ivengi/cleanzone';
import {ModalModule} from 'ngx-bootstrap';
import {UserService} from './user.service';
import {UserOverviewComponent} from './user-overview.component';
import {UserFormComponent} from './user-form.component';
import {SharedModule} from '../shared/shared.module';
import {MatSlideToggleModule} from '@angular/material';

@NgModule({
  declarations: [
    UserOverviewComponent,
    UserFormComponent
  ],
  exports: [
    UserOverviewComponent,
    UserFormComponent
  ],
  imports: [
    AuthenticationModule,
    SharedModule,
    ModalModule.forRoot(),
    ValidatorModule,
    MatSlideToggleModule,
  ],
  providers: [
    UserService
  ]
})
export class UserModule {

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/user/user.module.ts